export function scrollscreen(classs, item) {
    const commonBox = document.querySelector(classs);
    commonBox.scrollIntoView({
        block: item //元素到页面顶部，其他还有 end, center
    })
}

export function getRandomNumber(n) {
    let vstr = '';
    var arr1 = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");
    for (var i = 0; i < n; i++) {
        var m = Math.floor(Math.random() * 10);
        vstr += arr1[m]
    }
    return vstr;
}



//////////////////
// WEBPACK FOOTER
// ./tool/until.js
// module id = null
// module chunks = 